import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-45f781aa"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "h"
  }, null, -1);
});
var _hoisted_2 = {
  "class": "lotteryMain"
};
var _hoisted_3 = {
  "class": "sub-nav"
};
var _hoisted_4 = {
  "class": "main-page-full"
};
export default {
  __name: 'faq',
  setup: function setup(__props) {
    var toLink = reactive([{
      name: ' FAQ ',
      path: '/faq'
    }, {
      name: ' 技術支持 ',
      path: '/faq/tech'
    }, {
      name: ' 公告列表 ',
      path: '/faq/notice'
    }]);
    return function (_ctx, _cache) {
      var _component_router_link = _resolveComponent("router-link");
      var _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("nav", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toLink), function (item, index) {
        return _openBlock(), _createBlock(_component_router_link, {
          to: {
            path: item.path
          },
          key: index,
          "active-class": "router-link-exact-active"
        }, {
          "default": _withCtx(function () {
            return [_createElementVNode("span", null, _toDisplayString(item.name), 1)];
          }),
          _: 2
        }, 1032, ["to"]);
      }), 128))])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_router_view)])])], 64);
    };
  }
};